import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Header from '../layout/Header';
import NoScroll from './NoScroll';
import Wrap from "../layout/Wrap";
import Preloader from "../layout/Preloader";
import { GetBy } from '../_app/cuchillo/core/Element';
import gsap from 'gsap';

export default class Brunch extends NoScroll {
  video;
  back;

  constructor() {
    super();

    this.back = GetBy.id('back');
    gsap.set(this.back, { opacity: 0 });

    this.video = GetBy.class('project-detail', this.container)[0];
    gsap.set(this.video, { opacity: 0 });
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.show(() => {
        Header.directShow();
        Preloader.hide(() => { this.afterShow() });
      });
    } else {
      Wrap.show(() => { this.afterShow() });
    }
  }

  afterShow() {
    super.afterShow();
    Header.disable();

    document.body.classList.add('--vicio');
    gsap.to(this.video, { opacity: 1, duration: .5 });

    this.back.style.display = 'block';
    gsap.to(this.back, { opacity: 1, duration: .5 });
  }

  beforeHide() {
    super.beforeHide();

    gsap.to(this.back, {
      opacity: 0, duration: .5, onComplete: () => {
        this.back.style.display = 'none';
      }
    });
    Header.enable();
  }

  afterHide() {
    super.afterHide();

    if (!isMobile) document.body.classList.remove('--vicio');
  }
}

ControllerPage._addPage('vicio', Brunch);
